module.exports = __webpack_public_path__ + "fonts/euclid-square-400-italic.3566a0bd.ttf";